  // let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  
  // items.forEach(item => {
  //   item.addEventListener("mouseover", () => {
  //     item.setAttribute("open", true);
  //     item.querySelector("ul").addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //   item.addEventListener("mouseleave", () => {
  //     item.removeAttribute("open");
  //   });
  // });
  
  // });
  
/* ct-kortingsknop, 2026-09-30 (TIZA): een rond knopje linksonder dat de welkomstpop-up van
   MailerLite opnieuw opent, voor wie hem heeft weggeklikt. De pop-up zelf komt maar een keer per
   dag; ml('show', slug, true) slaat die frequentie over. Alle vier de pop-ups laden op elk domein,
   dus de slug gaat op domein en taalpad, anders opent hier de pop-up in een andere taal. Het knopje staat er
   alleen als de pop-up al een keer getoond is en nu dicht is, en verdwijnt na inschrijven: dat
   onthoudt MailerLite zelf in een cookie. Terugzetten: data/theme-backups/lintzagen-op-maat/
   2026-09-30-kortingsknop/kortingsknop.py --terug --apply */
(function () {
  if (window.ctKortingsknop) return; // custom.js staat twee keer in layout/theme.liquid
  window.ctKortingsknop = true;
  var pop = {
    'lintzagenopmaat.nl': { slug: 'PbBDaj', label: '-5%', tekst: 'Haal je 5% kortingscode op' },
    'custombandsaws.com': { slug: '4iqsZM', label: '-5%', tekst: 'Get your 5% discount code' },
    'bandsaegennachmass.de': { slug: 'nbXQFe', label: '-5 %', tekst: 'Ihren 5 %-Gutscheincode holen' }
  }[location.hostname.replace(/^www\./, '')];
  if (location.hostname.replace(/^www\./, '') === 'custombandsaws.com' && /^\/fr(?:\/|$)/.test(location.pathname)) {
    pop = { slug: '3MurIo', label: '-5%', tekst: 'Obtenir votre code de réduction de 5 %' };
  }
  if (!pop) return;

  function koekje(naam) {
    return document.cookie.split('; ').some(function (c) { return c.indexOf(naam + '=') === 0; });
  }

  function start() {
    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'ct-kortingsknop';
    knop.textContent = pop.label;
    knop.title = pop.tekst;
    knop.setAttribute('aria-label', pop.tekst);
    knop.hidden = true;
    knop.addEventListener('click', function () {
      window.ml('show', pop.slug, true);
      knop.hidden = true;
    });
    document.body.appendChild(knop);

    setInterval(function () {
      var p = window.ml && window.ml.fn && window.ml.fn.popups && window.ml.fn.popups[pop.slug];
      var id = p && (p.parentId || p.id);
      knop.hidden = !p || p.shown
        || !(koekje('mailerlite_forms_shown_' + id) || koekje('mailerlite:forms:shown:' + id))
        || koekje('mailerlite_forms_submitted_' + id) || koekje('mailerlite:forms:submitted:' + id);
    }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ct-staffel, 2026-10-07 (TIZA): de staffelkorting op lintzagen zichtbaar maken. De korting zelf
   zit niet hier maar in vier automatische kortingen in Shopify ('-5% (5+)', '-15% (10+)',
   '-20% (20+)', '-25% (30+)', op de collectie Band Saws). Dit blok toont alleen wat die doen:
   boven het aantal op elke lintzaagpagina een tabel onder elkaar, aantal, korting en prijs per
   stuk na korting; een klik op een regel zet het aantal daarop. Onderaan 100+ stuks op aanvraag,
   met een knop naar het contactformulier waarin product en maat al staan. In de winkelwagen
   hoeveel lintzagen er nog bij moeten voor de volgende trede. Verandert een korting in Shopify,
   dan moet TREDEN mee.
   TIZA 2026-10-22 (feedbackronde 4): de markt Duitsland heeft eigen treden in drie eigen
   kortingen ('-25% (3+)', '-35% (10+)', '-40% (20+)', alleen markt Duitsland; Tim: 3-9 stuks
   25%, geen aparte trede voor 3-4); de markt Duitsland is alleen het land DE, dus
   Shopify.country kiest de treden (punt 13).
   TIZA 2026-10-23: ook Oostenrijk, Zwitserland en Liechtenstein (Tim: alle Duitstalige landen;
   alle vier op het .de-domein, elk een eigen markt, en alle vier in de drie kortingen).
   Naast de prijs per stuk staat de prijs zonder btw, met het label van de pagina (punt 0).
   Terugzetten: data/theme-backups/lintzagen-op-maat/2026-10-07-staffel/staffel.py --terug --apply */
(function () {
  if (window.ctStaffel) return; // custom.js staat twee keer in layout/theme.liquid
  window.ctStaffel = true;

  var LAND = String((window.Shopify && Shopify.country) || '').toUpperCase();
  var TREDEN = ['DE', 'AT', 'CH', 'LI'].indexOf(LAND) !== -1
    ? [[3, 25], [10, 35], [20, 40]]
    : [[5, 5], [10, 15], [20, 20], [30, 25]]; // [vanaf aantal, procent]
  // Welke producten meetellen: dezelfde collectie als de kortingen (Band Saws, handle frontpage).
  // Niet op producttype of handle, want die zijn per taal vertaald (Koolstofstaal is op .de
  // 'flexback'). Lukt het ophalen niet, dan valt hij terug op het type van de hoofdtaal.
  var COLLECTIE = '/collections/frontpage/products.json?limit=250';
  var TYPE = 'lintzagen';
  var IDS = null;
  var taal = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = {
    nl: {
      best: 'De voordeligste korting is toegepast. Kortingen worden niet opgeteld.',
      kop: 'Staffelkorting', aanvraag: 'Op aanvraag', offerte: 'Offerte aanvragen voor 100+ stuks',
      bericht: 'Graag ontvang ik een offerte voor {product}{maat}.\nAantal: ',
      kolommen: ['Aantal', 'Korting', 'Prijs p/st'], stuks: '{r} stuks', een: 'lintzaag', meer: 'lintzagen',
      geen: 'Nog {n} {stuk} voor {p} staffelkorting',
      tussen: '{c} staffelkorting op je lintzagen. Nog {n} voor {p}',
      max: '{c} staffelkorting op je lintzagen'
    },
    de: {
      best: 'Der günstigste Rabatt wurde angewendet. Rabatte werden nicht kombiniert.',
      kop: 'Staffelrabatt', aanvraag: 'Auf Anfrage', offerte: 'Angebot für 100+ Stück anfragen',
      bericht: 'Bitte senden Sie mir ein Angebot für {product}{maat}.\nMenge: ',
      kolommen: ['Menge', 'Rabatt', 'Preis/Stk.'], stuks: '{r} Stück', een: 'Bandsägeblatt', meer: 'Bandsägeblätter',
      geen: 'Noch {n} {stuk} bis {p} Staffelrabatt',
      tussen: '{c} Staffelrabatt auf Ihre Bandsägeblätter. Noch {n} bis {p}',
      max: '{c} Staffelrabatt auf Ihre Bandsägeblätter'
    },
    en: {
      best: 'The best discount has been applied. Discounts are not combined.',
      kop: 'Volume discount', aanvraag: 'On request', offerte: 'Request a quote for 100+ blades',
      bericht: 'Please send me a quote for {product}{maat}.\nQuantity: ',
      kolommen: ['Quantity', 'Discount', 'Price each'], stuks: '{r} blades', een: 'blade', meer: 'blades',
      geen: '{n} more {stuk} for {p} volume discount',
      tussen: '{c} volume discount on your blades. {n} more for {p}',
      max: '{c} volume discount on your blades'
    },
    fr: {
      best: 'La remise la plus avantageuse est appliquée. Les remises ne se cumulent pas.',
      kop: 'Remise sur quantité', aanvraag: 'Sur demande', offerte: 'Demander un devis pour 100+ pièces',
      bericht: 'Merci de m’envoyer un devis pour {product}{maat}.\nQuantité : ',
      kolommen: ['Quantité', 'Remise', 'Prix/pièce'], stuks: '{r} pièces', een: 'lame', meer: 'lames',
      geen: 'Encore {n} {stuk} pour {p} de remise sur quantité',
      tussen: '{c} de remise sur vos lames. Encore {n} pour {p}',
      max: '{c} de remise sur vos lames'
    }
  }[taal] || null;
  if (!T) return;

  function pct(p) { return taal === 'de' || taal === 'fr' ? p + ' %' : p + '%'; }
  function vul(s, w) { return s.replace(/\{(\w+)\}/g, function (_, k) { return w[k]; }); }
  function huidig(aantal) {
    var t = null;
    TREDEN.forEach(function (r) { if (aantal >= r[0]) t = r; });
    return t;
  }
  function volgende(aantal) {
    for (var i = 0; i < TREDEN.length; i++) if (aantal < TREDEN[i][0]) return TREDEN[i];
    return null;
  }
  function lintzaag(id, type) {
    return IDS ? IDS.indexOf(Number(id)) !== -1 : String(type).toLowerCase() === TYPE;
  }
  function haalIds() {
    try {
      var bewaard = JSON.parse(sessionStorage.getItem('ctStaffelIds') || 'null');
      if (bewaard && bewaard.length) return Promise.resolve(bewaard);
    } catch (e) {}
    return fetch(COLLECTIE, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ids = (d.products || []).map(function (p) { return Number(p.id); });
        if (!ids.length) return null;
        try { sessionStorage.setItem('ctStaffelIds', JSON.stringify(ids)); } catch (e) {}
        return ids;
      })
      .catch(function () { return null; });
  }

  /* Geld. De prijs komt van het scherm (.pr_regular_inc, die de configurator bijwerkt) en gaat in
     dezelfde notatie terug: '€93,57' op .nl en .de, '£55.84' in het VK. Shopify trekt de korting
     per stuk af en rondt die naar beneden af op een cent (gemeten: 5% van 93,57 is 4,67), dus de
     prijs per stuk is prijs min afgeronde korting. Zo staat hier hetzelfde als in de wagen. */
  var GETAL = /\d[\d.,\s  ']*[.,]\d{2}(?!\d)/;
  function centen(tekst) {
    var m = String(tekst || '').match(GETAL);
    return m ? parseInt(m[0].replace(/\D/g, ''), 10) : null;
  }
  function geld(voorbeeld, c) {
    var m = voorbeeld.match(GETAL);
    if (!m) return '';
    var decimaal = m[0].charAt(m[0].length - 3);
    var duizend = (m[0].slice(0, -3).match(/\D/) || [''])[0];
    var heel = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
    return voorbeeld.replace(m[0], heel + decimaal + ('0' + (c % 100)).slice(-2));
  }
  function naKorting(c, p) { return c - Math.floor(c * p / 100); }

  /* De tabel op de productpagina, alleen bij een lintzaag. Een regel per trede, zonder regel voor
     het aantal onder de eerste trede (Tim); elke regel is een knop die het aantal op zijn
     ondergrens zet. */
  var RIJEN = TREDEN;
  var OFFERTE_VANAF = 100; // daarboven geen prijs maar een offerte (Tim)
  function bereik(i) {
    var van = RIJEN[i][0], volgend = RIJEN[i + 1];
    return van + '-' + ((volgend ? volgend[0] : OFFERTE_VANAF) - 1);
  }
  function contactadres(bericht) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'pages/contact' + (bericht ? '?ct_offerte=' + encodeURIComponent(bericht) : '');
  }
  function offertebericht(houder) {
    var titel = houder.querySelector('.product__title h1, .product__title .h1') || document.querySelector('.product__title h1, .product__title .h1'); // TIZA 2026-10-19: alleen de kop zelf; het blok bevat ook een <style> en een tweede kop
    var product = (titel ? titel.textContent : document.title).replace(/\s+/g, ' ').trim();
    // Wat de configurator in de verborgen velden zet: '6000.00 mm', '25 mm', '3 TPI', '0.60'.
    var delen = ['Length', 'Width', 'TPI', 'Thickness'].map(function (k) {
      var v = houder.querySelector('input[name="properties[' + k + ']"]');
      var w = v && v.value ? v.value.trim() : '';
      if (k === 'Length') w = w.replace(/\.00 mm$/, ' mm');
      if (k === 'Thickness' && /^\d+([.,]\d+)?$/.test(w)) w += ' mm';
      return w;
    }).filter(Boolean);
    return vul(T.bericht, { product: product, maat: delen.length ? ' (' + delen.join(', ') + ')' : '' });
  }
  /* Op de contactpagina: het bericht invullen dat de offerteknop meegaf, als het veld nog leeg is. */
  function offerteInvullen() {
    var bericht;
    try { bericht = new URLSearchParams(location.search).get('ct_offerte'); } catch (e) { return; }
    var veld = document.getElementById('ContactForm-body');
    if (!bericht || !veld || veld.value) return;
    veld.value = bericht;
    veld.dispatchEvent(new Event('input', { bubbles: true }));
    var formulier = document.getElementById('ContactForm');
    if (formulier) formulier.scrollIntoView({ block: 'start' });
  }

  function productpagina() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!meta || !lintzaag(meta.id, meta.type)) return;
    var config = document.querySelector('.ct-ps-wrapper');
    var houder = config && config.parentElement;
    if (!houder || houder.querySelector('.ct-staffel')) return;

    function cel(tag, klasse, tekst) {
      var e = document.createElement(tag);
      e.className = klasse;
      if (tekst) e.textContent = tekst;
      return e;
    }
    var blok = cel('div', 'ct-staffel');
    var kop = cel('p', 'ct-staffel__kop', T.kop);
    blok.appendChild(kop);
    var koprij = cel('div', 'ct-staffel__rij ct-staffel__rij--kop');
    koprij.setAttribute('aria-hidden', 'true');
    T.kolommen.forEach(function (k) { koprij.appendChild(cel('span', '', k)); });
    blok.appendChild(koprij);
    var lijst = cel('ul', 'ct-staffel__treden');
    RIJEN.forEach(function (r, i) {
      var li = document.createElement('li');
      var knop = cel('button', 'ct-staffel__rij');
      knop.type = 'button';
      knop.setAttribute('data-vanaf', r[0]);
      knop.setAttribute('data-procent', r[1]);
      knop.setAttribute('aria-pressed', 'false');
      knop.appendChild(cel('span', 'ct-staffel__aantal', vul(T.stuks, { r: bereik(i) })));
      knop.appendChild(cel('span', 'ct-staffel__korting', r[1] ? '-' + pct(r[1]) : '-'));
      knop.appendChild(cel('span', 'ct-staffel__prijs'));
      knop.addEventListener('click', function () {
        var veld = houder.querySelector('.quantity__input');
        if (!veld) return;
        veld.value = String(r[0]);
        veld.dispatchEvent(new Event('input', { bubbles: true }));
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      });
      li.appendChild(knop);
      lijst.appendChild(li);
    });
    blok.appendChild(lijst);

    // 100+ stuks: geen trede maar een offerte. De regel zet geen aantal; de knop opent het
    // contactformulier met product en gekozen maat al in het bericht (zie offerteInvullen).
    var aanvraag = cel('div', 'ct-staffel__rij ct-staffel__rij--aanvraag');
    aanvraag.appendChild(cel('span', 'ct-staffel__aantal', vul(T.stuks, { r: OFFERTE_VANAF + '+' })));
    aanvraag.appendChild(cel('span', 'ct-staffel__korting', T.aanvraag));
    aanvraag.appendChild(cel('span', 'ct-staffel__prijs', T.aanvraag));
    blok.appendChild(aanvraag);
    var offerte = cel('a', 'ct-staffel__offerte', T.offerte);
    offerte.href = contactadres('');
    offerte.addEventListener('click', function () { offerte.href = contactadres(offertebericht(houder)); });
    blok.appendChild(offerte);

    var aantalveld = houder.querySelector('.product-form__quantity');
    if (aantalveld) houder.insertBefore(blok, aantalveld);
    else config.parentNode.insertBefore(blok, config.nextSibling);

    var knoppen = [].slice.call(lijst.querySelectorAll('.ct-staffel__rij'));
    function licht() {
      var veld = houder.querySelector('.quantity__input');
      var aantal = parseInt(veld && veld.value, 10) || 1;
      var rij = null;
      RIJEN.forEach(function (r) { if (aantal >= r[0]) rij = r; });
      knoppen.forEach(function (k) {
        var aan = !!rij && +k.getAttribute('data-vanaf') === rij[0];
        k.classList.toggle('is-actief', aan);
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
    }
    var bron = houder.querySelector('.pr_regular_inc');
    // De prijs zonder btw staat ernaast op de pagina, met een eigen label in de taal van de site
    // ('excl. BTW'). Excl. per stuk is de prijs na korting maal dezelfde verhouding, zodat de btw
    // van de markt (ct-btw-tarief) vanzelf meekomt.
    var bronEx = houder.querySelector('.pr_regular_exc');
    var labelEx = bronEx && bronEx.nextElementSibling ? bronEx.nextElementSibling.textContent.trim() : '';
    if (!document.getElementById('ct-staffel-excl-stijl')) {
      var stijl = document.createElement('style');
      stijl.id = 'ct-staffel-excl-stijl';
      stijl.textContent = '.ct-staffel__prijs{white-space:normal}' +
        '.ct-staffel__excl{display:inline-block;white-space:nowrap;margin-left:.5rem;font-weight:400;' +
        'font-size:.85em;color:rgba(var(--color-foreground),.65)}' +
        '.ct-staffel__rij.is-actief .ct-staffel__excl{color:rgba(255,255,255,.8)}';
      document.head.appendChild(stijl);
    }
    function prijzen() {
      var tekst = bron ? bron.textContent.trim() : '';
      var c = centen(tekst);
      var tekstEx = bronEx ? bronEx.textContent.trim() : '';
      var cEx = centen(tekstEx);
      knoppen.forEach(function (k) {
        var plek = k.querySelector('.ct-staffel__prijs');
        var na = c ? naKorting(c, +k.getAttribute('data-procent')) : 0;
        var nieuw = c ? geld(tekst, na) : '';
        var ex = c && cEx && labelEx ? geld(tekstEx, Math.round(na * cEx / c)) + ' ' + labelEx : '';
        if (plek.getAttribute('data-ct') === nieuw + '|' + ex) return;
        plek.setAttribute('data-ct', nieuw + '|' + ex);
        plek.textContent = nieuw;
        if (ex) {
          var s = document.createElement('span');
          s.className = 'ct-staffel__excl';
          s.textContent = ex;
          plek.appendChild(s);
        }
      });
      blok.classList.toggle('ct-staffel--zonder-prijs', !c);
    }
    houder.addEventListener('change', licht);
    houder.addEventListener('input', licht);
    houder.addEventListener('click', function () { setTimeout(licht, 0); });
    if (bron) new MutationObserver(prijzen).observe(bron, { childList: true, characterData: true, subtree: true });
    if (bronEx) new MutationObserver(prijzen).observe(bronEx, { childList: true, characterData: true, subtree: true });
    licht();
    prijzen();
  }

  /* De regel in de winkelwagenlade en op /cart. */
  function tekst(aantal, wagen) {
    if (!aantal) return '';
    // TIZA 2026-10-19: read actual Shopify allocations, never infer a saving from quantity.
    if ((wagen.cart_level_discount_applications || []).some(function (d) {
      return Number(d.total_allocated_amount) > 0;
    })) return T.best;
    var applied = 0;
    (wagen.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var d = allocation.discount_application || {}, p = Number(d.value);
        if (d.value_type === 'percentage' && /% \(/.test(d.title || '') && p < 100) {
          applied = Math.max(applied, p);
        }
      });
    });
    if (!applied && huidig(aantal)) return '';
    var c = applied ? [aantal, applied] : null, v = volgende(aantal);
    if (!v) return vul(T.max, { c: pct(c[1]) });
    var n = v[0] - aantal;
    if (!c) return vul(T.geen, { n: n, stuk: n === 1 ? T.een : T.meer, p: pct(v[1]) });
    return vul(T.tussen, { c: pct(c[1]), n: n, p: pct(v[1]) });
  }

  function plekken() {
    var uit = [];
    var lade = document.querySelector('cart-drawer .cart-drawer__footer') || document.querySelector('cart-drawer .drawer__footer');
    if (lade) uit.push(lade);
    var pagina = document.querySelector('.cart__footer .cart__blocks') || document.querySelector('.cart__footer');
    if (pagina) uit.push(pagina);
    return uit;
  }

  var bezig = false, nogmaals = false;
  function winkelwagen() {
    if (bezig) { nogmaals = true; return; }
    var waar = plekken();
    if (!waar.length) return;
    bezig = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (wagen) {
        var aantal = 0;
        (wagen.items || []).forEach(function (i) {
          if (lintzaag(i.product_id, i.product_type)) aantal += i.quantity;
        });
        var t = tekst(aantal, wagen);
        plekken().forEach(function (plek) {
          var regel = plek.querySelector(':scope > .ct-staffel-regel');
          if (!regel) {
            regel = document.createElement('p');
            regel.className = 'ct-staffel-regel';
            plek.insertBefore(regel, plek.firstChild);
          }
          if (regel.textContent !== t) regel.textContent = t;
          regel.hidden = !t;
        });
      })
      .catch(function () {})
      .then(function () {
        bezig = false;
        if (nogmaals) { nogmaals = false; winkelwagen(); }
      });
  }

  var wacht;
  function eigen(knoop) {
    return knoop.nodeType === 1 && knoop.classList.contains('ct-staffel-regel');
  }
  function start() {
    offerteInvullen();
    haalIds().then(function (ids) {
      IDS = ids;
      productpagina();
      winkelwagen();
    });
    new MutationObserver(function (records) {
      var raak = records.some(function (m) {
        var doel = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (!doel || !doel.closest('cart-drawer, cart-items, .cart__footer')) return false;
        if (doel.closest('.ct-staffel-regel')) return false;
        var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
        return !(nodes.length && nodes.every(eigen));
      });
      if (!raak) return;
      clearTimeout(wacht);
      wacht = setTimeout(winkelwagen, 250);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
